import React from 'react';

import { getUsageStrokeColor } from 'components/Fragments/CreditUsageCircleGraph/CreditUsageCircleGraph';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';

import { ReactComponent as LightBulbOnFilled } from 'style/icons/lightbulb-on-filled.svg';

import './CreditUsageDials.scss';
import classnames from 'classnames';
import CircleGraph from '../../CircleGraph/CircleGraph';
import { ConditionalRendering } from 'helpers/conditionalRedering.helper';
const CreditUsageDials = ({
  className,
  currentCreditUsage,
  predictedCreditUsage,
  currentCreditUsageTitle = 'current credit usage',
  predictedCreditUsageTitle = 'potential credit usage',
  width = 136,
  mobileWidth = 110,
  showBottomCopies = false,
  bottomLeftCopy,
  bottomRightCopy,
  disclaimerCopy = 'Always try to keep your credit usage under 10%',
}) => {
  const percentageSign = usage => (usage === 'N/A' ? '' : '%');

  return (
    <div className="padlr26">
      <FlexContainer
        className={classnames('CreditUsageDials', 'column-gap-40', className)}
        alignItemsCenter
        justifyCenter
      >
        <FlexContainer column alignItemsCenter justifyCenter>
          <Label type="caption" className="toUpper fontGray6 text-center">
            {currentCreditUsageTitle}
          </Label>
          <CircleGraph
            className="margt16"
            datatestid="current-credit-usage"
            percent={currentCreditUsage}
            strokeWidth={8}
            width={width}
            mobileWidth={mobileWidth}
            titleText={`${currentCreditUsage}${percentageSign(
              currentCreditUsage,
            )}`}
            subTitleText="Usage"
            strokeFill={getUsageStrokeColor(currentCreditUsage)}
            pageType="newCardScoreIncrease"
          />
          <ConditionalRendering isTrue={showBottomCopies}>
            <div className="text-center margt16 margb16">{bottomLeftCopy}</div>
          </ConditionalRendering>
        </FlexContainer>
        <FlexContainer column alignItemsCenter justifyCenter>
          <Label type="caption" className=" toUpper fontGray6 text-center">
            {predictedCreditUsageTitle}
          </Label>
          <CircleGraph
            className="margt16"
            datatestid="predicted-credit-usage"
            percent={predictedCreditUsage}
            strokeWidth={8}
            width={width}
            mobileWidth={mobileWidth}
            titleText={`${predictedCreditUsage}${percentageSign(
              predictedCreditUsage,
            )}`}
            subTitleText="Usage"
            strokeFill={getUsageStrokeColor(predictedCreditUsage)}
            pageType="newCardScoreIncrease"
          />
          <ConditionalRendering isTrue={showBottomCopies}>
            <div className="text-center margt16 margb16">{bottomRightCopy}</div>
          </ConditionalRendering>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer justifyCenter>
        <LightBulbOnFilled
          className="margr8"
          role="img"
          aria-label="lightBulb"
        />
        <Label type="Body-2" className="padt4">
          {disclaimerCopy}
        </Label>
      </FlexContainer>
    </div>
  );
};

export default CreditUsageDials;
